/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ConversationType {
    SUPPORT = 'support',
    TALENT_MANAGER = 'talentManager',
    PROJECT = 'project',
}
